import React from 'react';
import { Typography, TypographyProps } from '@mui/material';

const GradientText: React.FC<TypographyProps> = ({ sx, ...props }) => (
  <Typography
    sx={{
      color: '#ffffff',
      fontWeight: 700,
      ...sx,
    }}
    {...props}
  />
);

export default GradientText;
